import { render } from "./SignupAndClaimPartner.vue?vue&type=template&id=7fcc604d&ts=true"
import script from "./SignupAndClaimPartner.vue?vue&type=script&lang=ts"
export * from "./SignupAndClaimPartner.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__